<template>
  <div class="h-full">
    <div v-if="!current" class="h-full">
      <div v-for="topic in sortedGroups" v-bind:key="topic.id">
        <div class="subgroup flex justify-between items-center" @click="setCurrentGroup(topic)">

          <div class="flex gap-12 items-center">
            <img :src="topic.getIconUrl()" class="max-h-46"/>
            <span>{{ topic.getName(language) }}</span>
          </div>
          <div class="open-pois justify-self-end">
            <svg class="h-18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.63281 9.88379C10.1211 9.39551 10.1211 8.60254 9.63281 8.11426L2.13281 0.614259C1.64453 0.125977 0.851561 0.125977 0.36328 0.614259C-0.125001 1.10254 -0.125001 1.89551 0.36328 2.38379L6.98047 9.00098L0.367187 15.6182C-0.121094 16.1064 -0.121094 16.8994 0.367187 17.3877C0.855469 17.876 1.64844 17.876 2.13672 17.3877L9.63672 9.8877L9.63281 9.88379Z" fill="#0F417C"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div v-if="current" class="h-full">



      <div v-if="currentPOI" class="h-full">

        <SinglePOI @directionsOpened="directionsOpened" :currentPOI="currentPOI" :setCurrentPOI="setCurrentPOI"></SinglePOI>

      </div>
      <div v-if="!currentPOI" class="h-full flex flex-col">
        <div class="back-outer-wrapper">
          <div class="back-wrapper">
            <div @click="backButtonClick()" class="group-back-button flex flex-row">
              <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.366211 8.61719C-0.12207 9.10547 -0.12207 9.89844 0.366211 10.3867L7.86621 17.8867C8.35449 18.375 9.14746 18.375 9.63574 17.8867C10.124 17.3984 10.124 16.6055 9.63574 16.1172L3.01855 9.5L9.63184 2.88281C10.1201 2.39453 10.1201 1.60156 9.63184 1.11328C9.14355 0.625 8.35059 0.625 7.86231 1.11328L0.362305 8.61328L0.366211 8.61719Z" fill="#0F417C"/>
              </svg>
              <WFTranslate k="back">Back</WFTranslate>
            </div>
          </div>
        </div>

        <div class="flex-1 overflow-y-auto overflow-x-hidden">

          <div v-if="getCurrentPOIS().length > 0" style="padding-bottom: 1rem;">
            <div v-for="poi in getCurrentPOIS()" v-bind:key="poi.id">
              <div class="subgroup flex justify-between items-center" @click="setCurrentPOI(poi)">

                <div class="flex gap-12 items-center">
                  <img :src="poi.getIconUrl() ?? current.getIconUrl()" class="max-h-46"/>
                  <span>{{ poi.getName(language) }}</span>
                </div>
                <div class="open-pois justify-self-end">
                  <div class="flex justify-between items-center">
                    <div v-if="poi.getFloor()" class="mr-10 poi-floor-name">
                      {{poi.getFloor().getName(language)}}
                    </div>
                    <svg class="h-18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.63281 9.88379C10.1211 9.39551 10.1211 8.60254 9.63281 8.11426L2.13281 0.614259C1.64453 0.125977 0.851561 0.125977 0.36328 0.614259C-0.125001 1.10254 -0.125001 1.89551 0.36328 2.38379L6.98047 9.00098L0.367187 15.6182C-0.121094 16.1064 -0.121094 16.8994 0.367187 17.3877C0.855469 17.876 1.64844 17.876 2.13672 17.3877L9.63672 9.8877L9.63281 9.88379Z" fill="#0F417C"/>
                    </svg>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div v-if="getCurrentSubGroups().length > 0" class="flex-1 overflow-y-auto overflow-x-hidden" style="padding-bottom: 1rem;">
            <div v-for="topic in getCurrentSubGroups()" v-bind:key="topic.id">
              <div class="subgroup flex justify-between items-center" @click="setCurrentGroup(topic)">
                <div style="flex: 1;"><img :src="topic.getIconUrl()" style="display: inline-block;" class="max-h-46 mr-10"/> {{ topic.getName(language) }}</div>
                <div class="open-pois justify-self-end">
                  <svg class="h-18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.63281 9.88379C10.1211 9.39551 10.1211 8.60254 9.63281 8.11426L2.13281 0.614259C1.64453 0.125977 0.851561 0.125977 0.36328 0.614259C-0.125001 1.10254 -0.125001 1.89551 0.36328 2.38379L6.98047 9.00098L0.367187 15.6182C-0.121094 16.1064 -0.121094 16.8994 0.367187 17.3877C0.855469 17.876 1.64844 17.876 2.13672 17.3877L9.63672 9.8877L9.63281 9.88379Z" fill="#0F417C"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div v-if="current.getDescription(language).length >= 5">
            <SingleGroup :group="current" />
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>

import { mapState } from "vuex";
import SinglePOI from "@/components/SinglePOI";
import SingleGroup from "@/components/SingleGroup";

export default {
  components: {
    SingleGroup,
    SinglePOI,
  },
  props: ['mainSlug'],
  data() {
    return {
      current: null,
      currentPOI: null,
      sortedGroups: [],
      count: 0
    }
  },
  computed: {
    ...mapState('wf', ['poiGroups', 'language', 'searchVisible']),
    schengenZone() {
      return this.$store.state.schengenZone;
    },
    currentPage() {
      return this.$store.state.currentPage;
    },
    mainTabResetKey() {
      return this.$store.state.mainTabResetKey;
    },
    accessible() {
      return this.$store.state.accessible;
    },
  },
  methods: {
    directionsOpened(poi) {
      this.$emit('directionsOpened', poi);
    },
    backButtonClick() {
      const topLevelSlugs = ['schengen-map', 'schengen-info', 'nonschengen-map', 'nonschengen-info'];

      const previousGroup = this.poiGroups.reduce((result, group) => {

        if (this.current.parent_id == group.id) {
          if (!group.slug || !topLevelSlugs.includes(group.slug)) {
            return group;
          }
        }
        return result;
      }, null);

      this.setCurrentGroup(previousGroup);
    },
    sortGroups() {
      const mainSlug = this.$store.state.currentPage == 'grouppois' ? 'map' : 'info';

      const mainGroup = this.poiGroups.reduce((result, group) => {
        if (group.showInMenu && group.slug === this.$store.state.schengenZone + '-' + mainSlug) {
          result = group;
        }
        return result;
      }, null);

      if (!mainGroup) {
        return [];
      }

      const groups = this.poiGroups.reduce((result, group) => {
        if (group.showInMenu && group.getName(this.language) && group.parent_id == mainGroup.id) {
          result.push(group);
        }
        return result;
      }, []);

      return groups.sort((a, b) => {
        if (a && b) {
          return a.order - b.order;
        }
        return 0;
      });

    },
    getCurrentPOIS() {
      if (!this.current) {
        return [];
      }
      return this.current.pois.reduce((acc, poi) => {
        if (poi.showInMenu) {
          acc.push(poi);
        }
        return acc;
      }, []);
    },
    getCurrentSubGroups() {
      const groups = this.poiGroups.reduce((result, group) => {

        if (group.showInMenu == true && group.getName(this.language) && group.parent_id == this.current.id) {
          result.push(group);
        }
        return result;
      }, []);

      return groups.sort((a, b) => {
        if (a && b) {
          return a.order - b.order;
        }
        return 0;
      });
    },
    setCurrentGroup(group) {
      if (group && group.getShowInTopMenu()) {
        const nearest = this.$wayfinder.getNearestPOI(this.$wayfinder.getKiosk(), group.pois);
        this.setCurrentPOI(nearest);

        return;
      }
      this.current = group;
    },
    setCurrentPOI(poi) {
      this.$store.dispatch('setPOI', poi);
      this.$store.dispatch('setDirectionsOpened', false);
      this.currentPOI = poi;
      this.$wayfinder.statistics.onClick(poi.id, "menu");
    },
  },
  mounted() {
    this.sortedGroups = this.sortGroups();
  },
  watch: {
    poiGroups: function () {
      this.sortedGroups = this.sortGroups();
    },
    current: function() {

    },
    '$store.state.schengenZone': function() {
      this.current = null;
      this.currentPOI = null;
      this.sortedGroups = this.sortGroups();
    },
    '$store.state.currentPage': function() {
      this.current = null;
      this.currentPOI = null;
      this.sortedGroups = this.sortGroups();
    },
    mainTabResetKey: function() {
      this.current = null;
      this.currentPOI = null;
      this.sortedGroups = this.sortGroups();
    }
  }
}
</script>

<style lang="postcss">
  .subgroup {
    padding: 1.6rem 0;
    border-bottom: 1px solid rgba(156, 158, 187, 1);
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 2.4rem;
  }
  .back-wrapper {
    display: inline-block;
  }
  .group-back-button {
    align-items: center;
    border-radius: 2.4rem;
    padding: 0.6rem 1.2rem;
    border: 1px solid #0F417C;
    font-size: 1.6rem;

    svg {
      margin-right: 1rem;
    }
  }
  .back-outer-wrapper {
    border-bottom: 1px solid rgba(156, 158, 187, 1);
    padding-bottom: 1rem;
    margin-bottom: 1rem;
  }
  .poi-floor-name {
    font-weight: 500;
    font-size: 1.6rem;
  }


</style>
